module.exports = __webpack_public_path__ + "static/media/funnelp.fe9d20a4.jpg";